import { toast } from "react-toastify";
import { useConnectedUser } from "../../context/connected-user.context";
import { useEffect, useState } from "react";
import { Web3Button } from "../../design-system/button";

export const ClaimFromSnapshotComponent: React.FC<{}> = () => {
    const { contract: cdkContract, reloadAllBalances } = useConnectedUser();
    const [canClaimFromSnapshot, setCanClaimFromSnapshot] = useState<boolean>(false);

    useEffect(() => {
        if (cdkContract) {
            setCanClaimFromSnapshot(true);
        }
    }, [cdkContract]);

    const claimFromSnapshot = async () => {
        if (cdkContract) {
            try {
                await cdkContract.cdkFacet.doClaimFromSnapshot();
                toast.success('Claimed from snapshot successfully');
                await reloadAllBalances();
            } catch (error) {
                toast.info('You have already claimed from snapshot or no $CDKs to claim.');
            }
        }
    };

    return (
        <>
            {canClaimFromSnapshot && (
                <div>
                    <div>
                        <p>If you have $CDKs on Polygon (claim.cdktoken.io), you must first claim</p>
                        <p>them by clicking on the "Claim my $CDK" button.</p>
                        <p>You will receive your new $CDK on Avalanche for the same amount.</p>
                        <p>This operation is done once and for all.</p>
                    </div>
                    <div className="mt-4">
                        <Web3Button text="Claim from snapshot" web3Action={() => claimFromSnapshot()} />
                    </div>
                </div>
            )}
        </>
    )
}